import { GridCellProps, GridColumnProps } from "@progress/kendo-react-grid";
import GridCellNumericEditor from "../utilities/GridCellNumericEditor";

type RenderStringCell = (props: GridCellProps) => React.JSX.Element;

export default function buildAllocationColumnProps(
  showBusinessTypes: boolean,
  commodityTypesGridCellRender: RenderStringCell,
  businessTypesGridCellRender: RenderStringCell,
) {
  const columnConfigs: GridColumnProps[] = [
    { field: "name", title: "Name", width: 150, editable: true, editor: "text" },
    {
      field: "1",
      title: "Jan",
      width: 90,
      editable: true,
      cells: { data: GridCellNumericEditor },
    },
    {
      field: "2",
      title: "Feb",
      width: 90,
      editable: true,
      cells: { data: GridCellNumericEditor },
    },
    {
      field: "3",
      title: "Mar",
      width: 90,
      editable: true,
      cells: { data: GridCellNumericEditor },
    },
    {
      field: "4",
      title: "Apr",
      width: 90,
      editable: true,
      cells: { data: GridCellNumericEditor },
    },
    {
      field: "5",
      title: "May",
      width: 90,
      editable: true,
      cells: { data: GridCellNumericEditor },
    },
    {
      field: "6",
      title: "Jun",
      width: 90,
      editable: true,
      cells: { data: GridCellNumericEditor },
    },
    {
      field: "7",
      title: "Jul",
      width: 90,
      editable: true,
      cells: { data: GridCellNumericEditor },
    },
    {
      field: "8",
      title: "Aug",
      width: 90,
      editable: true,
      cells: { data: GridCellNumericEditor },
    },
    {
      field: "9",
      title: "Sep",
      width: 90,
      editable: true,
      cells: { data: GridCellNumericEditor },
    },
    {
      field: "10",
      title: "Oct",
      width: 90,
      editable: true,
      cells: { data: GridCellNumericEditor },
    },
    {
      field: "11",
      title: "Nov",
      width: 90,
      editable: true,
      cells: { data: GridCellNumericEditor },
    },
    {
      field: "12",
      title: "Dec",
      width: 90,
      editable: true,
      cells: { data: GridCellNumericEditor },
    },
    {
      field: "commodityTypeObjects",
      title: "Commodities",
      width: 368,
      editable: true,
      cells: { data: commodityTypesGridCellRender },
    },
  ];

  if (showBusinessTypes) {
    columnConfigs.push({
      field: "businessTypes",
      title: "Areas",
      width: 161,
      editable: true,
      cells: { data: businessTypesGridCellRender },
    });
  }

  return columnConfigs;
}
